<template>
<div>
  <div class="card-header text-center border-bottom-0">
    <h1 class="h4">{{ $t("design.colors") }}</h1>
  </div>
  <div class="card-body grid-kernel system_colors">
    <h3 class="border-bottom pb-2 mb-3">Main colors</h3>
    <b-row>
      <b-col lg="3">
        <div class="card brandingColor">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$brandingColor</em> <br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="card accentColor">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$accentColor</em> <br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card secondaryColor">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$secondaryColor</em> <br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="card auxColor">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$auxColor</em> <br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="card aquaColor">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$aquaColor</em> <br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col lg="3">
        <div class="card brandingColorHover">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$brandingColorHover</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="card accentColorHover">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$accentColorHover</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card secondaryColorHover">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$secondaryColorHover</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="card auxColorHover">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$auxColorHover</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="card aquaColorHover">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$aquaColorHover</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
    </b-row>
    <h4 class="mt-4 mb-4">State colors</h4>
    <b-row>
      <b-col lg="3">
        <div class="card bootInfo">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootInfo</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bootSuccess">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootSuccess</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bootDanger">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootDanger</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bootWarning">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootWarning</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col lg="3">
        <div class="card bootInfoHover">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootInfoHover</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bootSuccessHover">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootSuccessHover</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bootDangerHover">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootDangerHover</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bootWarningHover">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootWarningHover</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
    </b-row>
    <h4 class="mt-4 mb-4">Gray colors</h4>
    <b-row>
      <b-col lg="3">
        <div class="card altColor">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$altColor</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card borderColor">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$borderColor</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card fontColor">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$fontColor</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bodyBg">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bodyBg</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
    </b-row>
    <h3 class="border-bottom pb-2 mb-4 mt-4">R web-safe colors</h3>
    <b-row>
      <b-col lg="3">
        <div class="card brandingColorWeb">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$brandingColorWeb</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="card accentColorWeb">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$accentColorWeb</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card secondaryColorWeb">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$secondaryColorWeb</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="card auxColorWeb">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$auxColorWeb</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="2">
        <div class="card aquaColorWeb">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$aquaColorWeb</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col lg="3">
        <div class="card bootInfoWeb">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootInfoWeb</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bootSuccessWeb">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootSuccessWeb</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bootDangerWeb">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootDangerWeb</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="card bootWarningWeb">
          <div class="card-body"></div>
          <div class="card-footer">
            <em>$bootWarningWeb</em><br>
            HEX <span></span>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</div>
</template>
<style lang="scss" scoped="true">

  @import 'src/assets/styles/mixins.scss';
  @import 'src/assets/styles/libs.scss';

  @mixin boxcolor($color) {
    .card-body {
      background: $color;
    }
    .card-footer {
      span {
        &:before {
          content: "#{$color}";
          display: inline-block;
        }
      }
    }
  }
  .system_colors {
    .card-body {
      @include border-top-radius($baseRadius)
      min-height: 50px;
      height: 120px;
    }
    .card-footer {
      padding: 5px;
    }
  }
  .grid-kernel  {
    .row {
      margin-right: -12px;
      margin-left: -12px;
      [class*="col-"] {
        padding-right: 12px;
        padding-left: 12px;
      }
    }
  }
  .brandingColor {
    @include boxcolor($brandingColor);
  }
  .accentColor {
    @include boxcolor($accentColor);
  }
  .secondaryColor {
    @include boxcolor($secondaryColor);
  }
  .auxColor {
    @include boxcolor($auxColor);
  }
  .aquaColor {
    @include boxcolor($aquaColor);
  }
  .brandingColorHover {
    @include boxcolor($brandingColorHover);
  }
  .accentColorHover {
    @include boxcolor($accentColorHover);
  }
  .secondaryColorHover {
    @include boxcolor($secondaryColorHover);
  }
  .auxColorHover {
    @include boxcolor($auxColorHover);
  }
  .aquaColorHover {
    @include boxcolor($aquaColorHover);
  }
  .brandingColorWeb {
    @include boxcolor($brandingColorWeb);
  }
  .accentColorWeb {
    @include boxcolor($accentColorWeb);
  }
  .secondaryColorWeb {
    @include boxcolor($secondaryColorWeb);
  }
  .auxColorWeb {
    @include boxcolor($auxColorWeb);
  }
  .aquaColorWeb {
    @include boxcolor($aquaColorWeb);
  }
  .bootInfo {
    @include boxcolor($bootInfo);
  }
  .bootSuccess {
    @include boxcolor($bootSuccess);
  }
  .bootDanger {
    @include boxcolor($bootDanger);
  }
  .bootWarning {
    @include boxcolor($bootWarning);
  }
  .bootInfoHover {
    @include boxcolor($bootInfoHover);
  }
  .bootSuccessHover {
    @include boxcolor($bootSuccessHover);
  }
  .bootDangerHover {
    @include boxcolor($bootDangerHover);
  }
  .bootWarningHover {
    @include boxcolor($bootWarningHover);
  }
  .bootInfoWeb {
    @include boxcolor($bootInfoWeb);
  }
  .bootSuccessWeb {
    @include boxcolor($bootSuccessWeb);
  }
  .bootDangerWeb {
    @include boxcolor($bootDangerWeb);
  }
  .bootWarningWeb {
    @include boxcolor($bootWarningWeb);
  }
  .altColor {
    @include boxcolor($altColor);
  }
  .borderColor {
    @include boxcolor($borderColor);
  }
  .fontColor {
    @include boxcolor($fontColor);
  }
  .bodyBg {
    @include boxcolor($bodyBg);
  }
</style>
<script>
export default {
  name: 'Colors',
  components: {

  },
  data: function () {
    return {
      user: {}
    };
  },
  methods: {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Styles/Colors.vue